const Initreducer = (state, { type, payload }) => {
    switch (type) {
        case 'settoken':
            return { ...state, token: payload, islogin: true };
        case 'setinit':
            return { ...state, loading: false, user: payload.user, role: payload.role, expense_type: payload.expense_type, active_expense_type: payload.active_expense_type, expense: payload.expense, category: payload.category, unit: payload.unit, company: payload.company, customer: payload.customer, item: payload.item, today_invoice: payload.today_invoice, return_item_company: payload.return_item_company, removeditem: payload.removeditem, dollar_price: payload.dollar_price, mizania: payload.mizania };
        case 'setcompanyinvoiceitem':
            return { ...state, company_invoice_item: payload };
        case 'setsellinvoice':
            return { ...state, today_invoice: payload };
        case 'setexpense_report':
            return { ...state, expense_report: payload };
        case 'setcompany_report':
            return { ...state, company_report: payload };
        case 'setbroke':
            return { ...state, broke: payload };
        case 'setexpense':
            return { ...state, expense: payload };
        case 'setitem':
            return { ...state, item: payload };
        case 'setcustomer':
            return { ...state, customer: payload };
        case 'setcustomer_ledger':
            return { ...state, ledger_customer_id: payload.ledger_customer_id, ledger_customer_name: payload.ledger_customer_name, ledger_customer_phone: payload.ledger_customer_phone, ledger_customer_address: payload.ledger_customer_address };
        case 'setitem_ledger':
            return { ...state, ledger_item_id: payload.ledger_item_id, ledger_item_code: payload.ledger_item_code, ledger_item_name: payload.ledger_item_name, ledger_item_unit_one: payload.ledger_item_unit_one, ledger_item_unit_many: payload.ledger_item_unit_many, ledger_item_unit_one_of_many: payload.ledger_item_unit_one_of_many };
        case 'setcompany_ledger':
            return { ...state, ledger_company_id: payload.ledger_company_id, ledger_company_name: payload.ledger_company_name, ledger_company_phone: payload.ledger_company_phone, ledger_company_address: payload.ledger_company_address };
        case 'setmizania_customer_ledger':
            return { ...state, mizania_date: payload.mizania_date, mizania_customer_id: payload.mizania_customer_id, mizania_customer_name: payload.mizania_customer_name, mizania_customer_phone: payload.mizania_customer_phone, mizania_customer_address: payload.mizania_customer_address };
        case 'setmizania_company_ledger':
            return { ...state, mizania_date: payload.mizania_date, mizania_company_id: payload.mizania_company_id, mizania_company_name: payload.mizania_company_name, mizania_company_phone: payload.mizania_company_phone, mizania_company_address: payload.mizania_company_address };
        case 'setmizania_form_date':
            return { ...state, mizania_form_date: payload };
        case 'setmizania_form_table_type':
            return { ...state, mizania_form_table_type: payload };
        case 'setmizania_form_ddata':
            return { ...state, mizania_form_ddata: payload };
        case 'setmost_sell_report':
            return { ...state, most_sell_report: payload };
        case 'setleast_sell_report':
            return { ...state, least_sell_report: payload };
        case 'setcategory_sell_report':
            return { ...state, category_sell_report: payload };
        case 'setmost_profitable_sell_report':
            return { ...state, most_profitable_sell_report: payload };
        case 'setsummary_sell_report':
            return { ...state, summary_sell_report: payload.summary_sell_report, summary_sell_profit_report: payload.summary_sell_profit_report };
        case 'setsummary_expense_report':
            return { ...state, summary_expense_report: payload };
        case 'setcustomer_loan_report':
            return { ...state, customer_loan_report: payload };
        case 'setloan_in_report':
            return { ...state, loan_in_report: payload };
        case 'setsummary_loan_in_report':
            return { ...state, summary_loan_in_report: payload };
        case 'setcompany_loan_report':
            return { ...state, company_loan_report: payload };
        case 'setloan_out_report':
            return { ...state, loan_out_report: payload };
        case 'setsummary_loan_out_report':
            return { ...state, summary_loan_out_report: payload };
        case 'setledger_report':
            return { ...state, ledger: payload };
        case 'setbrokereport':
            return { ...state, total_broke_qty: payload.total_broke_qty, total_broke_price: payload.total_broke_price };
        case 'setmost_broke_report':
            return { ...state, most_broke_report: payload };
        case 'setmost_gift_report':
            return { ...state, most_gift_report: payload };
        case 'setsummary_broke_report':
            return { ...state, summary_broke_report: payload.summary_broke_report, summary_gift_report: payload.summary_gift_report };
        case 'filtercompanyinvoiceitem':
            return { ...state, company_invoice_item: state.company_invoice_item.filter((lis) => lis.company_invoice_id != payload) };
        case 'setsell_report':
            return { ...state, total_sell_qty: payload.total_sell_qty, total_sell_price: payload.total_sell_price, total_return_qty: payload.total_return_qty, total_return_price: payload.total_return_price };
        case 'setreturnbybarcode':
            return { ...state, returnbybarcode: payload };
        case 'setitemsellreport':
            return { ...state, item_sell_report_qty: payload.sell_qty, item_sell_report_price: payload.sell_price };
        case 'setreturnitemcompany':
            return { ...state, return_item_company: payload };
        case 'setsummary_report':
            return { ...state, summary_report_total_sell: payload.summary_report_total_sell, summary_report_total_profit: payload.summary_report_total_profit, summary_report_total_expense: payload.summary_report_total_expense, summary_report_total_gift: payload.summary_report_total_gift, summary_report_total_broke: payload.summary_report_total_broke, summary_report_total_stock_price: payload.summary_report_total_stock_price, summary_report_total_loan_in: payload.summary_report_total_loan_in, summary_report_total_loan_out: payload.summary_report_total_loan_out, summary_report_total_save: payload.summary_report_total_save, profitdetail_array: payload.profitdetail_array };
        case 'setsummaryreport':
            return { ...state, summary_report_sell_array: payload.summary_report_sell_array, summary_report_expense_amount: payload.summary_report_expense_amount, summary_report_damage_qty: payload.summary_report_damage_qty, summary_report_damage_amount: payload.summary_report_damage_amount, summary_report_return_item_company_qty: payload.summary_report_return_item_company_qty, summary_report_return_item_company_amount: payload.summary_report_return_item_company_amount, summary_report_total_save: payload.summary_report_total_save };
        case 'loadingFalse':
            return { ...state, loading: false };
        case 'loadingTrue':
            return { ...state, loading: true };
        case 'authcheckFalse':
            return { ...state, authcheck: false };
        case 'authcheckTrue':
            return { ...state, authcheck: true };
        case 'setstok':
            return { ...state, stok: payload.stok, total_stock_price: payload.total_stock_price };
        default:
            return state;
    }
}

export default Initreducer;